import { Command } from 'pos/common';
import * as SalesStore from '../SalesStore';
import { TicketLineDTO, Permission } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { CustomerDisplay } from 'pos/services';
import { editLineNotes } from './editLineComposition';

declare global {
	interface CommandType {
		addTicketLineNote: (line: TicketLineDTO) => Promise<Result>
	}
}

Command.register('addTicketLineNote', Preconditions.ensure(Permission.Ticket_AddLineNotes), async (line: TicketLineDTO): Promise<Result> => {

	const result = await editLineNotes(line);

	if (!result.ok)
		return Result.error();

	await SalesStore.addLineNote(line, result.value.preparationNotes);
	await CustomerDisplay.displayLineNote(SalesStore.getTicket(), SalesStore.getLineById(line.Id));
	return Result.ok();
});
